export default {
    name: 'queueFilter',
    namespaced: true,
    state: {
        filtro: {
            show: false,
            company_filter: null,
            care_unit_filter: null,
            sector_filter: null,
            vns_filter: null
        }
    },
    getters: {
        all (state) {
            return state.filtro
        },
        getSpecific (state, key) {
            return state.filtro[key]
        },
    },
    mutations: {
        setAll (state, obj) {
            state.filtro = obj
        },
        setSpecific (state, obj) {
            state.filtro = {...state.filtro, ...obj}
        },
    },
    actions: {
        setFiltro ({ commit, state }, obj) {
            commit('setAll', obj)
        },
        setSpecific ({ commit, state }, obj) {
            commit('setSpecific', obj)
        },
        reset ({ commit, state }) {
            commit('setSpecific', {
                show: false,
                company_filter: null,
                care_unit_filter: null,
                sector_filter: null,
                vns_filter: null
            })
        },
    }
}
